import { render } from "./saleslist.vue?vue&type=template&id=a5a69a42"
import script from "./saleslist.vue?vue&type=script&lang=js"
export * from "./saleslist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__